import React, { Component } from "react";
import { formBuilderGroups } from "../../../variables/formBuilderData";
import Collapsible from "react-collapsible";
import { translate } from "../../../utils/useful";

class ExistingForms extends Component {
    state = {
        closedGroups: {},
        showChildsSide: false
    };
    onDragStart = (e, rowId, type) => {
        let dataObject = { rowId, type, dropType: "NEW" };
        if (e.dataTransfer.setData) {
            e.dataTransfer.setData(
                "dragData",
                JSON.stringify(dataObject)
            );
        } else {
            e.dataTransfer.rowId = rowId;
            e.dataTransfer.type = type;
        }
        this.props.setElDragData(dataObject);
        this.props.setShowStructures();
    };


    toggleOpen = (key) => {
        let closedGroups = this.state.closedGroups
        closedGroups[key] = closedGroups[key] == null ? true : !closedGroups[key]
        this.setState({ closedGroups })
    }

    render() {
        const { formItems, hideHandlers } = this.props;

        return (
            <div className="column-forms-holder ">
                <div className="w-100 px-3 pb-3 pt-3 mb-3" style={{ backgroundColor: '#00000010' }}>
                    <p className="text-normal text-bold color-gray-3 m-0">From Builder</p>

                    <button onClick={() => { }} className='px-1 py-1  flexcc mt-1' style={{ filter: !this.state.type == null ? 'saturate(20%) ' : '', background: 'linear-gradient(to right,#9564FE, #7064FE)', borderRadius: 8, color: '#fff', transition: 'all 0.5s' }}>
                        <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }}>{translate("Save Form")}</p>
                        <div className='flexcc mld-3 p-1' style={{ background: 'linear-gradient(to right, #ffffff10, #ffffff20)', borderRadius: 8 }}>
                            <img className='invert' src='/assets/icons/useful/save.svg' height={18} />
                        </div>
                    </button>
                </div>

                {Object.values(formBuilderGroups).map((group, index) => {
                    return (

                        <div className="mb-3 pb-2 px-2 w-100" style={{ borderBottom: '1px solid #eee' }} key={group.key}>
                            <button className="p-0 px-2 mb-2 flexcb w-100" onClick={() => this.toggleOpen(group.key)} >
                                <div className="text-start">
                                    <p className="text-normal color-gray-3 ">{group.title}</p>
                                    {/* <p className="text-smallest " style={{color:'#9ab'}}>This is the description of this section</p> */}
                                </div>
                                <img className={"mld-2 transition opacity-2 " + (!this.state.closedGroups[group.key] ? 'rotate-90' : '')} src={'/images/nexts.png'} width="13px" alt="" />
                            </button>

                            <Collapsible open={!this.state.closedGroups[group.key]} transitionTime={100}>
                                <div className="d-flex mb-2" style={{ flexWrap: 'wrap', alignItems: "stretch" }}>

                                    {formItems.map((formItem, index) => {
                                        if (formItem.parent === group.key)
                                            return (
                                                <div className=" p-1 mb-0" style={{ width: '50%' }} key={formItem.type}>
                                                    <div
                                                        key={index}
                                                        className="form-item flexcc flex-column text-smaller pt-2 pb-2"
                                                        onDragStart={(e) =>
                                                            this.onDragStart(e, index, formItem.type)
                                                        }
                                                        onDragEnd={this.props.setShowStructures}
                                                        // onDragLeave={hideHandlers}
                                                        draggable
                                                    >
                                                        <img draggable={false} src={formItem.icon} height={30} />
                                                        <p draggable={false} className="mt-2 text-semibold color-gray-3">{formItem.label}</p>
                                                    </div>
                                                </div>
                                            );
                                    })
                                    }

                                </div>
                            </Collapsible>
                        </div>
                    )
                })}

            </div>
        );
    }
}



export default ExistingForms;